import { z } from 'zod'

import { FlowOrigin } from 'shared/api/common/schemas/flow/origin'
import { AdaptedMap, ById } from 'shared/api/common/schemas/templates/adaptedMap'
import { FlowItemSchema, SequenceItemSchema } from 'shared/api/common/schemas/templates/modelItems'

import { getNestedDependencies } from './getNestedDependencies'

type MapItem = ById[string]
type FlowItem = z.infer<typeof FlowItemSchema>
type SequenceItem = z.infer<typeof SequenceItemSchema>

const isFlowItem = (item: MapItem): item is FlowItem => 'origin' in item

const isSequenceItem = (item: MapItem): item is SequenceItem => 'messages' in item

const getIconCheckDependencies = (map: AdaptedMap, id: string): string[] => {
  const item: MapItem | undefined = map.byId[id]
  if (!item || !isSequenceItem(item)) {
    return map.dependencies[id] ?? []
  }
  return getNestedDependencies({ ...map.directDependencies, [id]: item.messages }, id)
}

export const getIsIconItem = (item?: MapItem): boolean =>
  item !== undefined && isFlowItem(item) && item.origin === FlowOrigin.icon

export const getHasIconDependency = (map: AdaptedMap, id: string): boolean =>
  getIconCheckDependencies(map, id).some((depId) => getIsIconItem(map.byId[depId]))
